export default __webpack_public_path__ + "static/20240723-4ce9c54b7f82f131c67c27bdfd7bbf73.png";